import { components, paths } from "@securityjourney/svc-code-sub/dist/gen/code_sub";

import { OpenApiFetchWrapper, type ServiceResponse } from "./openApiFetchWrapper";

export type CodeSubmission = components["schemas"]["securityjourney.proto.code_sub.CodeSubmission"];
export type RetrieveCodeSubmissionsRequest =
  components["schemas"]["securityjourney.proto.code_sub.RetrieveCodeSubmissionRequest"];
export type CodeSubmissions = {
  userCodeSubmissions?: components["schemas"]["securityjourney.proto.code_sub.CodeSubmission"][];
};
export type CodeSubTestResult = components["schemas"]["securityjourney.proto.code_sub.TestResult"];
export type CodeSubVolume = components["schemas"]["securityjourney.proto.code_sub.Volume"];

type SubmissionsQuery = NonNullable<
  paths["/svc/code-sub/submissions"]["get"]["parameters"]["query"]
>;
// The service accepts whole-field `since`/`until` timestamps for pagination, but the
// generated query type only models the flattened `since.seconds`/`since.nanos` form.
// Extend it with the whole-field keys so the request the client actually sends is typed.
type SubmissionsQueryWithRange = SubmissionsQuery & {
  since?: RetrieveCodeSubmissionsRequest["since"];
  until?: RetrieveCodeSubmissionsRequest["until"];
};

class CodeSubClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super();
  }

  async retrieveCodeSubmission(
    req: RetrieveCodeSubmissionsRequest
  ): Promise<ServiceResponse<CodeSubmissions>> {
    const query: SubmissionsQueryWithRange = {
      lessonId: req.lessonId,
      lessonVersion: req.lessonVersion,
      limit: req.limit,
      since: req.since,
      until: req.until,
    };
    return await this.get("/svc/code-sub/submissions", { params: { query } });
  }

  async retrieveCodeSubmissionsAdmin(
    email: string,
    until?: Date,
    limit = 50
  ): Promise<ServiceResponse<CodeSubmissions>> {
    const encodedEmail = btoa(
      String.fromCharCode(
        ...new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(email)))
      )
    );
    const params = {
      query: {
        email: encodedEmail,
        until: until ? until.toISOString() : undefined,
        limit,
      },
    };
    const response = await this.get("/svc/code-sub/submissions/admin", { params });
    return response;
  }
}

let codeSubClientInstance: CodeSubClient | null = null;

export const getCodeSubClient = (): CodeSubClient => {
  if (!codeSubClientInstance) {
    codeSubClientInstance = new CodeSubClient();
  }
  return codeSubClientInstance;
};
